export default __webpack_public_path__ + "static/media/ot.1937d7ef.svg";